import React, { useState } from 'react'
import { BsArrowRightCircle } from 'react-icons/bs'
import { createFeedback, updateFeedback } from '../../Api/feedbacks'
import { toast } from 'react-toastify'
import './feedback.css'
import logAppEvent from '../../Api/appEventsLogging'
import { useSelector } from 'react-redux'
import { useSearchParams } from 'react-router-dom'

const Feedback = ({
  reference_id,
  feedback_type,
  isActionItems,
  actionItemsTotal,
}) => {
  const [feedbackId, setFeedbackId] = useState(null)
  const [showFeedback, setShowFeedback] = useState(true)

  const [rating, setRating] = useState(0)
  const [comment, setComment] = useState('')
  
  const user = useSelector((state) => state?.user?.data)
  const [searchParams] = useSearchParams()
  
  const handleEventLog = (eventType) => {
    if (eventType === 'smileyClicked') {
      let eventName

      switch (feedback_type) {
      case 1:
        eventName = 'transumm_fdbk_submit_summary_click'
        break
      case 3:
        eventName = 'transumm_fdbk_submit_transcripts_click'
        break
      case 4:
        eventName = 'transumm_smiley_fdbk_actionitems_click'
        break
      default:
        eventName = 'transumm_fdbk_submit_default_click'
      }

      const eventId = searchParams.get('eventId')
      logAppEvent(eventName, {
        user_id: user?.id,
        event_id: eventId,
      })   
      return
    }

    if (eventType === 'feebackInputSubmit') {
      let eventName
      switch (feedback_type) {
      case 1:
        eventName = 'transumm_fdbk_submit_summary_click'
        break
      case 3:
        eventName = 'transumm_fdbk_submit_transcripts_click'
        break
      case 4:
        eventName = 'transumm_fdbk_submit_actionitems_click'
        break
      default:
        eventName = 'transumm_fdbk_submit_default_click'
      }
      logAppEvent(eventName, {
        user_id: user?.id,
      })
      return
    }
  }

  const handleFeedback = async (feedback_type, rating, comment) => {
    if (!reference_id) return
    if (feedback_type < 0 || feedback_type > 4) return
    if (rating < 0 || rating > 3) {
      toast.error('Rating is required')
      return
    }

    if (feedbackId) {
      const apiResponse = await updateFeedback(feedbackId, {
        rating,
        comment: comment?.trim() || '',
      })
      return apiResponse
    }

    const apiResponse = await createFeedback({
      feedback_type,
      comment: comment?.trim() || '',
      rating,
      reference_id,
    })
    if (apiResponse?.feedbackId) setFeedbackId(apiResponse.feedbackId)
    return apiResponse
  }

  const handleSmileyFeedbackClick = async (rating) => {
    setRating(rating)
    const apiResponse = await handleFeedback(feedback_type, rating, comment)
    if (apiResponse) handleEventLog('smileyClicked')
  }

  const handleFeedbackInputSubmit = async () => {
    const apiResponse = await handleFeedback(feedback_type, rating, comment)
    if (!apiResponse) return
    setShowFeedback(false)
    handleEventLog('feebackInputSubmit')
  }

  if (!showFeedback) {
    return (
      <div className='feedback'>
        <h4>
          You’ve just helped make
          <br />
          Arrowhead more accurate! 🚀
        </h4>
        <button
          onClick={() => setShowFeedback(true)}
          className='close-button'
        >
          Back
        </button>
      </div>
    )
  }

  return (
    <div className='feedback'>
      <>
        <h4>
          {!isActionItems ? 'Was this helpful?' : 'Do you agree with this?'}
        </h4>
        <p>This will help us improve our responses for you!</p>
        <div className='rating'>
          {[{
            activeIcon: '/assets/images/sad-gray.png', 
            icon: '/assets/images/sad.png' 
          }, {
            activeIcon: '/assets/images/okay-gray.png',
            icon: '/assets/images/okay.png',
          }, {
            activeIcon: '/assets/images/happy-gray.png',
            icon: '/assets/images/happy.png',
          }].map(({activeIcon, icon}, index) => {
            if (isActionItems && actionItemsTotal < 0) return <></>
            return (
              <button key={`feedback-${index}`} type='button' onClick={() => handleSmileyFeedbackClick(index+1)}>
                {rating === index+1 ? (
                  <img src={activeIcon} alt='' />
                ) : (
                  <img src={icon} alt='' />
                )}
              </button>
            )
          })}
        </div>
        
        {feedbackId && (
          <div
            className={
              comment?.trim() !== '' || (rating > 0 && rating < 4)
                ? 'comment active'
                : 'comment'
            }
          >
            <input
              autoFocus
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              onKeyDown={(e) => e.key === 'Enter' && handleFeedbackInputSubmit()}
              placeholder='can you give more details here plz?'
            />
            <button onClick={() => handleFeedbackInputSubmit()}>
              <BsArrowRightCircle size={13} />
            </button>
          </div>
        )}
      </>
    </div>
  )
}

export default Feedback
